package top.wcpe.allincore.dsl.ir.model

import kotlin.jvm.JvmStatic

/**
 * UI 视觉 modifier opcode。
 *
 * v32 起 UiNode 追加有序 modifier 链段；v33 起追加程序化材质栈 / history / particle。
 * opcode 只承载结构类型，字段仍用 UiBinding 编码。
 */
object ModifierOpcodes {

    const val OP_STYLE: Byte = 0x01
    const val OP_SURFACE: Byte = 0x02
    const val OP_SHADOW: Byte = 0x03
    const val OP_NEON: Byte = 0x04
    const val OP_RIPPLE: Byte = 0x05
    const val OP_TEXTURE: Byte = 0x06
    const val OP_FLOW: Byte = 0x07
    const val OP_ENERGY: Byte = 0x08
    const val OP_FILTER: Byte = 0x09
    const val OP_BACKDROP: Byte = 0x0A
    const val OP_BLEND: Byte = 0x0B
    // master v33+ 程序化材质 / 历史 / 粒子
    const val OP_TEXTURE_LAYER: Byte = 0x0C
    const val OP_MATERIAL_OVERLAY: Byte = 0x0D
    const val OP_HISTORY_LAYER: Byte = 0x0E
    const val OP_WORN_FRAME: Byte = 0x0F
    const val OP_RUNE_OVERLAY: Byte = 0x10
    const val OP_MATERIAL_GRAPH: Byte = 0x11
    const val OP_SHADER_LAYER: Byte = 0x12
    const val OP_PARTICLE_LAYER: Byte = 0x13

    @JvmStatic
    fun kindToOpcode(kind: String): Byte {
        return when (kind) {
            "style" -> OP_STYLE
            "surface" -> OP_SURFACE
            "shadow" -> OP_SHADOW
            "neon" -> OP_NEON
            "ripple" -> OP_RIPPLE
            "texture" -> OP_TEXTURE
            "flow" -> OP_FLOW
            "energy" -> OP_ENERGY
            "filter" -> OP_FILTER
            "backdrop" -> OP_BACKDROP
            "blend" -> OP_BLEND
            "textureLayer" -> OP_TEXTURE_LAYER
            "materialOverlay" -> OP_MATERIAL_OVERLAY
            "historyLayer" -> OP_HISTORY_LAYER
            "wornFrame" -> OP_WORN_FRAME
            "runeOverlay" -> OP_RUNE_OVERLAY
            "materialGraph" -> OP_MATERIAL_GRAPH
            "shaderLayer" -> OP_SHADER_LAYER
            "particleLayer" -> OP_PARTICLE_LAYER
            else -> throw IllegalArgumentException("未知 modifier kind: $kind")
        }
    }

    @JvmStatic
    fun opcodeToKind(opcode: Int): String {
        return when (opcode) {
            OP_STYLE.toInt() -> "style"
            OP_SURFACE.toInt() -> "surface"
            OP_SHADOW.toInt() -> "shadow"
            OP_NEON.toInt() -> "neon"
            OP_RIPPLE.toInt() -> "ripple"
            OP_TEXTURE.toInt() -> "texture"
            OP_FLOW.toInt() -> "flow"
            OP_ENERGY.toInt() -> "energy"
            OP_FILTER.toInt() -> "filter"
            OP_BACKDROP.toInt() -> "backdrop"
            OP_BLEND.toInt() -> "blend"
            OP_TEXTURE_LAYER.toInt() -> "textureLayer"
            OP_MATERIAL_OVERLAY.toInt() -> "materialOverlay"
            OP_HISTORY_LAYER.toInt() -> "historyLayer"
            OP_WORN_FRAME.toInt() -> "wornFrame"
            OP_RUNE_OVERLAY.toInt() -> "runeOverlay"
            OP_MATERIAL_GRAPH.toInt() -> "materialGraph"
            OP_SHADER_LAYER.toInt() -> "shaderLayer"
            OP_PARTICLE_LAYER.toInt() -> "particleLayer"
            else -> throw IllegalStateException("未知 modifier opcode: $opcode")
        }
    }
}
